import React from 'react';
import { ArrowRight, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <div className="relative bg-gray-900 overflow-hidden h-[90vh] min-h-[600px] flex items-center" data-id="element-196">
      {/* Background Image with Slow Zoom Parallax */}
      <motion.div className="absolute inset-0" initial={{
      scale: 1
    }} animate={{
      scale: 1.1
    }} transition={{
      duration: 20,
      repeat: Infinity,
      repeatType: 'reverse',
      ease: 'linear'
    }} data-id="element-197">
        <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=2075&q=80" alt="Luxury home in Chatsworth" className="w-full h-full object-cover opacity-40" data-id="element-198" />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/80 via-gray-900/40 to-gray-900/90" data-id="element-199"></div>
      </motion.div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center w-full" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="inline-flex items-center space-x-2 border border-white/20 rounded-full px-4 py-1.5 mb-8 backdrop-blur-md bg-white/5" data-id="element-201">
          <MapPin className="w-4 h-4 text-brand-gold" data-id="element-202" />
          <span className="text-xs font-medium tracking-widest text-white uppercase" data-id="element-203">
            Chatsworth • 91311 Focus
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-4xl md:text-6xl lg:text-7xl font-serif text-white max-w-4xl leading-tight mb-6 drop-shadow-lg" data-id="element-204">
          Protecting equity. <br data-id="element-205" />
          <span className="italic text-brand-gold font-light" data-id="element-206">
            Strengthening community.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-200 max-w-2xl mb-10 font-light leading-relaxed drop-shadow-md" data-id="element-207">
          Kareem Jamal helps Chatsworth families maintain and improve their
          personal residences. Whether it's strategic selling, smart upgrades,
          or adding an ADU, Kareem positions your home to build long-term wealth
          while keeping the 91311 community strong.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6 w-full sm:w-auto" data-id="element-208">
          <a href="#lead-form" className="w-full sm:w-auto bg-brand-gold hover:bg-[#B0885B] text-white px-8 py-4 rounded-full text-sm font-bold tracking-wide uppercase transition-all shadow-[0_0_20px_rgba(196,154,108,0.3)] hover:shadow-[0_0_30px_rgba(196,154,108,0.5)] hover:-translate-y-1 flex items-center justify-center" data-id="element-209">
            Get Your Equity Audit
            <ArrowRight className="ml-2 w-4 h-4" data-id="element-210" />
          </a>
          <a href="#about" className="w-full sm:w-auto bg-transparent border border-white/30 hover:border-white hover:bg-white/5 text-white px-8 py-4 rounded-full text-sm font-bold tracking-wide uppercase transition-all backdrop-blur-sm hover:-translate-y-1" data-id="element-211">
            Meet Kareem
          </a>
        </motion.div>
      </div>
    </div>;
}